export type Environment = 'local' | 'staging' | 'prod'

export const getEnvironmentName = (): Environment => {
  const envName = process.env.REACT_APP_NAME?.toLowerCase().trim() || ''

  if (envName.startsWith('staging')) {
    return 'staging'
  }

  if (envName.startsWith('prod')) {
    return 'prod'
  }

  return 'local'
}

const environment = getEnvironmentName()

export const useEnvironment = () => ({
  environment,
  isLocal: environment === 'local',
  isStage: environment === 'staging',
  isProd: environment === 'prod',
})